import { render, staticRenderFns } from "./PortalAccordion.vue?vue&type=template&id=d321e636&"
import script from "./PortalAccordion.vue?vue&type=script&lang=ts&"
export * from "./PortalAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports